import React from "react";
import { Box, Typography, Button, IconButton } from "@mui/material";
import HomeIcon from "@mui/icons-material/Home";
import { useNavigate } from "react-router-dom";
import backgroundImage from "../assets/background.webp";
import companyLogo from "../assets/WWDS Logo white.png";

const Intro = () => {
  const navigate = useNavigate();

  return (
    <Box
  sx={{
    minHeight: "100vh", 
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    backgroundImage: `url(${backgroundImage})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundAttachment: "fixed", 
    color: "white",
    textAlign: "center",
    padding: "2rem",
    position: "relative",
    overflowY: "auto", // Allow scrolling when content exceeds the height
  }}
>
    {/* Home Icon */}
    <Box
      sx={{
        position: "absolute",
        top: { xs: "1rem", sm: "1.5rem" },
        left: { xs: "1rem", sm: "1.5rem" },
        zIndex: 10,
      }}
      onClick={() => navigate("/")}
    >
      <IconButton>
        <HomeIcon fontSize="large" sx={{ color: "white" }} />
      </IconButton>
    </Box>
  
    {/* Main Content */}
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        paddingTop: { xs: "4rem", sm: "2rem" }, // Extra padding for smaller screens
      }}
    >
      <Typography
        variant="h2"
        sx={{
          fontSize: { xs: "2.5rem", sm: "3rem" },
          fontWeight: 700,
          textTransform: "uppercase",
          marginBottom: "2rem",
        }}
      >
        INSIGHTHUB
      </Typography>
      <Typography
        variant="h6"
        sx={{
          fontSize: { xs: "1.2rem", sm: "1.5rem" },
          marginBottom: "2rem",
          lineHeight: "1.8",
          maxWidth: "800px",
          fontWeight: 300,
        }}
      >
        A platform designed to help businesses gather meaningful feedback from
        their employees.
      </Typography>
      <Typography
        variant="body1"
        sx={{
          fontSize: { xs: "1rem", sm: "1.2rem" },
          marginBottom: "2rem",
          lineHeight: "1.8",
          maxWidth: "800px",
        }}
      >
        InsightHub empowers businesses to grow by tracking employee satisfaction
        and identifying areas for improvement. With InsightHub, businesses can
        register and share feedback links via URL or QR code, enabling employees
        to provide feedback anonymously.
      </Typography>
  
      {/* Login Button */}
      <Button
        variant="contained"
        size="large"
        sx={{
          marginTop: "2rem",
          letterSpacing: "0.2rem",
          backgroundColor: (theme) => theme.palette.accent.main,
          color: "primary.main",
          borderRadius: "50px",
          padding: "0.25rem 3rem",
          fontSize: "1.75rem",
        }}
        onClick={() => navigate("/login")}
      >
        LOGIN
      </Button>
    </Box>
  
    {/* Footer */}
    <Box
      sx={{
        bottom: "1rem",
        mt: 2,
        textAlign: "center",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        color: "rgba(255, 255, 255, 0.8)",
        width: "100%",
      }}
    >
      <img
        src={companyLogo}
        alt="WhiteWall Digital Solutions"
        style={{
          width: "120px",
          height: "auto",
          marginBottom: "0.5rem",
        }}
      />
      <Typography variant="body2" sx={{ mb: 1 }}>
        Need an account?{" "}
        <a
          href="https://www.whitewall.om/#Contact-us"
          style={{
            textDecoration: "none",
            color: "#ffffff",
            fontWeight: "bold",
          }}
        >
          Register Now
        </a>
      </Typography>
      <Typography variant="body2">
        Powered by{" "}
        <a
          href="https://www.whitewall.om"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            textDecoration: "none",
            color: "#ffffff",
            fontWeight: "bold",
          }}
        >
          WhiteWall Digital Solutions
        </a>
      </Typography>
    </Box>
  </Box>
  
  );
};

export default Intro;
